/**
 * Mobile comparison table: pin a product to the left column and cycle others on the right.
 */
(function () {
  const ROOT = '[data-comparison-mobile-root]';

  /**
   * @param {HTMLElement} container
   * @param {string} col
   */
  function setCompareMobileCol(container, col) {
    container.querySelectorAll('[data-compare-mobile-col]').forEach((el) => {
      el.setAttribute('data-compare-mobile-col', String(col));
    });
  }

  /**
   * @param {HTMLElement} target
   * @param {HTMLTemplateElement} templateEl
   */
  function mountTemplate(target, templateEl) {
    target.textContent = '';
    target.appendChild(document.importNode(templateEl.content, true));
  }

  /**
   * @param {HTMLElement} root
   */
  function initRoot(root) {
    const n = parseInt(root.dataset.columnCount || '0', 10);
    if (n < 2 || root.dataset.comparisonPinInit === 'true') return;
    root.dataset.comparisonPinInit = 'true';

    const sectionId = root.dataset.sectionId;
    const unlockedPanel = root.querySelector('[data-comparison-unlocked-panel]');
    const lockedPanel = root.querySelector('[data-comparison-locked-panel]');
    const pinnedLeft = root.querySelector('[data-comparison-pinned-left]');
    const pinnedRight = root.querySelector('[data-comparison-pinned-right]');
    const lockLabelLock = root.dataset.i18nLock || 'Pin product';
    const lockLabelUnlock = root.dataset.i18nUnlock || 'Unpin product';

    /** @type {number | null} */
    let lockedIndex = null;
    let partnerCursor = 0;
    /** @type {number[]} */
    let partners = [];

    /**
     * @param {number} g
     * @returns {HTMLTemplateElement | null}
     */
    function templateByIndex(g) {
      const el = document.getElementById(`comparison-mobile-col--${sectionId}--${g}`);
      return el instanceof HTMLTemplateElement ? el : null;
    }

    function setLockButtonUi() {
      root.querySelectorAll('[data-comparison-lock]').forEach((btn) => {
        const g = parseInt(btn.dataset.globalIndex, 10);
        const lockedIcon = btn.querySelector('[data-lock-icon="locked"]');
        const unlockedIcon = btn.querySelector('[data-lock-icon="unlocked"]');
        const active = lockedIndex !== null && g === lockedIndex;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.setAttribute('aria-label', active ? lockLabelUnlock : lockLabelLock);
        if (lockedIcon && unlockedIcon) {
          lockedIcon.classList.toggle('hidden', active);
          unlockedIcon.classList.toggle('hidden', !active);
        }
        const lockedLabel = btn.querySelector('[data-lock-label="locked"]');
        const unlockedLabel = btn.querySelector('[data-lock-label="unlocked"]');
        if (lockedLabel && unlockedLabel) {
          lockedLabel.classList.toggle('hidden', active);
          unlockedLabel.classList.toggle('hidden', !active);
        }
      });
    }

    function mountPinned() {
      if (lockedIndex === null || !pinnedLeft || !pinnedRight || partners.length === 0) return;
      const leftT = templateByIndex(lockedIndex);
      const pi = partners[partnerCursor];
      const rightT = templateByIndex(pi);
      if (!leftT || !rightT) return;
      mountTemplate(pinnedLeft, leftT);
      mountTemplate(pinnedRight, rightT);
      setCompareMobileCol(pinnedLeft, 1);
      setCompareMobileCol(pinnedRight, 2);
    }

    function updateLockedNav() {
      const prev = root.querySelector('[data-comparison-locked-prev]');
      const next = root.querySelector('[data-comparison-locked-next]');
      const single = partners.length <= 1;
      if (prev) prev.disabled = single;
      if (next) next.disabled = single;
    }

    /** @param {number} index */
    function enterLocked(index) {
      lockedIndex = index;
      partners = [];
      for (let i = 0; i < n; i += 1) {
        if (i !== index) partners.push(i);
      }
      partnerCursor = 0;
      if (unlockedPanel) {
        unlockedPanel.classList.add('hidden');
        unlockedPanel.setAttribute('aria-hidden', 'true');
      }
      if (lockedPanel) {
        lockedPanel.hidden = false;
        lockedPanel.classList.remove('hidden');
        lockedPanel.setAttribute('aria-hidden', 'false');
      }
      setLockButtonUi();
      mountPinned();
      updateLockedNav();
    }

    function exitLocked() {
      lockedIndex = null;
      partners = [];
      partnerCursor = 0;
      if (pinnedLeft) pinnedLeft.textContent = '';
      if (pinnedRight) pinnedRight.textContent = '';
      if (lockedPanel) {
        lockedPanel.hidden = true;
        lockedPanel.classList.add('hidden');
        lockedPanel.setAttribute('aria-hidden', 'true');
      }
      if (unlockedPanel) {
        unlockedPanel.classList.remove('hidden');
        unlockedPanel.removeAttribute('aria-hidden');
      }
      setLockButtonUi();
    }

    /** @param {number} delta */
    function stepLocked(delta) {
      if (partners.length <= 1) return;
      partnerCursor = (partnerCursor + delta + partners.length) % partners.length;
      mountPinned();
    }

    root.addEventListener('click', (e) => {
      const unlockBtn = e.target.closest('[data-comparison-unlock]');
      if (unlockBtn && root.contains(unlockBtn)) {
        e.preventDefault();
        if (lockedIndex !== null) exitLocked();
        return;
      }

      const lockBtn = e.target.closest('[data-comparison-lock]');
      if (lockBtn && root.contains(lockBtn)) {
        e.preventDefault();
        const g = parseInt(lockBtn.dataset.globalIndex, 10);
        if (Number.isNaN(g)) return;
        if (lockedIndex === g) {
          exitLocked();
        } else {
          enterLocked(g);
        }
        return;
      }

      if (lockedIndex === null || !lockedPanel || lockedPanel.hidden) return;

      const prevBtn = e.target.closest('[data-comparison-locked-prev]');
      const nextBtn = e.target.closest('[data-comparison-locked-next]');
      if (prevBtn && root.contains(prevBtn)) {
        e.preventDefault();
        stepLocked(-1);
      } else if (nextBtn && root.contains(nextBtn)) {
        e.preventDefault();
        stepLocked(1);
      }
    });
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach((el) => {
      if (el instanceof HTMLElement) initRoot(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
